import { RebaseTranslations } from "@rebasepro/cms-types";

/**
 * Portuguese (pt) translations for @rebasepro/app.
 *
 * @group Core
 */
export const pt: RebaseTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Guardar",
    create: "Criar",
    create_copy: "Criar cópia",
    save_and_close: "Guardar e fechar",
    create_copy_and_close: "Criar cópia e fechar",
    create_and_close: "Criar e fechar",
    discard: "Descartar",
    clear: "Limpar",
    cancel: "Cancelar",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Editar",
    copy: "Copiar",
    delete: "Eliminar",
    delete_not_allowed: "Selecionou pelo menos uma entidade que não pode eliminar",
    edit_entity: "Editar",
    back_to_detail: "Voltar aos detalhes",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Eliminar?",
    delete_confirmation_body: "Esta ação eliminará a entidade. Tem a certeza?",
    delete_multiple_confirmation_body: "Esta ação eliminará as entidades selecionadas. Tem a certeza?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Alterações não guardadas",
    unsaved_changes_body: "Tem alterações não guardadas. Deseja descartá-las?",
    discard_changes: "Descartar alterações",
    keep_editing: "Continuar a editar",
    clear_form: "Limpar formulário?",
    discard_changes_confirmation: "Todas as alterações não guardadas serão perdidas. Esta ação não pode ser desfeita.",
    clear_form_confirmation: "Todos os valores introduzidos serão apagados. Esta ação não pode ser desfeita.",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Pesquisar",
    find_by_id: "Encontrar por ID",
    find_entity_by_id: "Encontrar entidade por ID",
    filter: "Filtrar",
    filters: "Filtros",
    records_in_view: "Registos nesta vista",
    clear_filter: "Limpar filtro",
    clear_filter_sort: "Limpar filtro/ordenação",
    clear_sort: "Limpar ordenação",
    sort: "Ordenar",
    sort_by: "Ordenar por",
    sort_then_by: "Depois por",
    sort_ascending: "Ordenar ascendente",
    sort_descending: "Ordenar descendente",
    sort_remove: "Remover ordenação",
    sort_move_up: "Tornar esta chave mais importante",
    sort_move_down: "Tornar esta chave menos importante",
    sort_remove_key: "Remover esta chave de ordenação",
    sort_key_position: "Chave de ordenação {{position}}",
    sort_shift_click_hint: "Shift+clique para adicionar uma coluna sob a ordenação atual",
    save_entity_before_subcollections: "Precisas de guardar a entidade antes de adicionar coleções adicionais",
    clear_all: "Limpar tudo",
    no_items: "Sem itens",
    no_entries_found: "Nenhum registo encontrado",
    all_entries_loaded: "Todos os {{count}} registos carregados",
    create_your_first_entry: "Crie o seu primeiro registo",
    no_results_filter_sort: "Sem resultados com o filtro/ordenação aplicado",
    no_results_search: "Nenhum resultado encontrado para \"{{search}}\"",
    add: "Adicionar",
    remove: "Remover",
    multiple_entities: "Múltiplas entidades",
    unsaved_changes: "Tem alterações não guardadas em {{collectionName}}.",
    so_empty: "Tão vazio...",
    no_results: "Sem resultados com o filtro/ordenação aplicado",
    refresh_data: "Atualizar dados",
    dark_mode: "Escuro",
    light_mode: "Claro",
    system_mode: "Sistema",
    join_newsletter: "Assine a newsletter, sem spam",
    ok: "Ok",
    save_collection_config: "Guardar estrutura da coleção",
    search_for_more_icons: "Pesquisar mais ícones…",
    ai_modified: "Modificado por IA",
    size_label: "Tamanho",
    group_by: "Agrupar por",
    initialize_kanban_order: "Inicializar Ordem Kanban",
    copy_id: "Copiar ID",
    add_specific: "Adicionar {{name}}",
    add_named: "Adicionar \"{{name}}\"",
    select_specific: "Selecionar {{name}}",
    select_from: "Selecionar de {{name}}",
    done: "Concluído",
    log_out: "Terminar sessão",
    column_cannot_be_edited: "Esta coluna não pode ser editada diretamente",
    close: "Fechar",
    hide_list: "Ocultar lista",
    show_list: "Mostrar lista",
    unsaved_local_changes: "Alterações locais não guardadas",
    unsaved_local_changes_description: "Este documento foi editado localmente e tem alterações não guardadas. Estas alterações locais serão perdidas se não as aplicar.",
    preview_changes: "Pré-visualizar alterações",
    apply_changes: "Aplicar alterações",
    discard_local_changes: "Descartar alterações locais",
    preview_local_changes: "Pré-visualizar alterações locais",
    preview_local_changes_description: "Estas são as alterações locais que serão aplicadas ao formulário.",
    type: "Tipo",
    string: "string",
    number: "número",
    boolean: "booleano",
    date: "data",
    map: "mapa",
    array: "lista",
    arrays_of_arrays_not_supported: "Listas de listas não são suportadas.",
    data_type_not_supported: "Tipo de dados {{dataType}} ainda não suportado",
    passkey_error_unsupported: "O seu dispositivo ou browser não suporta passkeys.",

    // ─── Entity form feedback ─────────────────────────────────────
    saved_correctly: "Guardado com sucesso",
    error_before_saving: "Erro ao preparar os dados",
    error_after_saving: "Erro no processamento pós-gravação",
    error_saving_entity: "Erro ao guardar a entidade",
    entity_does_not_exist: "Esta entidade não existe na base de dados",
    form_modified: "Este formulário foi modificado",
    form_in_sync: "O formulário atual está sincronizado com a base de dados",
    fix_errors_before_saving: "Corrija os erros destacados antes de guardar",

    admin: "Administrador",
    home: "Início",
    this_form_has_errors: "Este formulário tem erros",
    error_loading_navigation: "Erro ao carregar navegação",
    error_loading_auth: "Erro ao carregar autenticação",
    this_form_has_been_modified: "Este formulário foi modificado",
    current_form_in_sync: "O formulário atual está sincronizado com a base de dados",
    open_in_console: "Abrir na consola",
    collection_does_not_exist: "A coleção especificada não existe. Verifique a consola",
    unexpected_value: "Valor inesperado",
    unexpected_value_click_to_edit: "Valor inesperado. Clique para editar",
    unexpected_reference_value: "Valor de referência inesperado. Clique para editar",
    copy_url_to_clipboard: "Copiar URL para a área de transferência",
    open_image_in_new_tab: "Abrir imagem numa nova aba",
    reference_not_set: "Referência não definida",
    reference_does_not_exist: "A referência não existe",
    entity_not_found: "Entidade não encontrada",
    entity_not_found_body: "Este registo não existe, ou pode estar-lhe oculto pela segurança ao nível da linha.",
    back_to_collection: "Voltar a {{name}}",
    file_not_found: "Ficheiro não encontrado",
    unsaved_changes_in_entity: "Tem alterações não guardadas nesta entidade.",
    delete_this_role: "Eliminar esta função",
    no_roles_yet: "Ainda não tem nenhuma função.",
    create_default_roles: "Criar funções predefinidas",
    delete_role_confirmation: "Tem a certeza de que quer eliminar esta função?",
    delete_this_user: "Eliminar este utilizador",
    no_users_yet: "Ainda não existem utilizadores",
    add_logged_user_as_admin: "Adicionar o utilizador com sessão iniciada como administrador",
    add_current_user_as_admin: "Adicionar utilizador atual como administrador",
    create_default_roles_and_add_admin: "Criar funções predefinidas e adicionar utilizador atual como administrador",
    delete_user_confirmation: "Tem a certeza de que quer eliminar este utilizador?",
    create_your_users_and_roles: "Crie os seus utilizadores e funções",
    no_users_or_roles_defined: "Não tem utilizadores ou funções definidas. Pode criar funções predefinidas e adicionar o utilizador atual como administrador.",
    save_before_changing_schema: "Precisa de guardar o documento antes de alterar o esquema",
    edit_schema_for_this_form: "Editar esquema para este formulário",
    no_permissions_to_edit_collection: "Não tem permissões para editar esta coleção",
    browser_does_not_support_audio: "O seu browser não suporta o elemento de áudio.",
    user_not_found: "Utilizador não encontrado: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Eliminar",
    cannot_delete_selected: "Selecionou pelo menos uma entidade que não pode eliminar",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Adicionar",
    add_on_top: "Adicionar no topo",
    add_below: "Adicionar abaixo",
    add_to_field: "Adicionar a {{fieldName}}",
    value: "Valor",
    key: "Chave",
    drag_drop_multiple: "Arraste e solte ficheiros aqui, ou clique para selecionar. Arraste para reordenar.",
    drag_drop_single: "Arraste e solte um ficheiro aqui, ou clique para selecionar um",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Abrir menu",
    close_drawer: "Fechar painel lateral",
    navigation_drawer: "Painel lateral de navegação",
    collapse: "Recolher",
    expand: "Expandir",
    change_language: "Alterar idioma",
    toggle_theme: "Alternar tema",
    user_menu: "Menu do utilizador",

    // ─── Error states ─────────────────────────────────────────────
    error: "Erro",
    error_loading_data: "Não foi possível carregar os dados",
    error_check_server_logs: "Consulte os registos do servidor para mais detalhes.",
    error_technical_details: "Detalhes técnicos",
    error_uploading_file: "Erro ao carregar ficheiro",
    error_deleting: "Erro ao eliminar",
    error_before_delete: "Erro antes de eliminar",
    error_updating_asset: "Erro ao atualizar recurso",
    error_deleting_asset: "Erro ao eliminar recurso",
    error_firestore_index: "É necessário um índice Firestore para esta consulta.",
    create_index: "Criar índice",
    value_is_not_reference: "O valor não é uma referência.",
    click_to_edit: "Clique para editar",
    data_is_not_array_of_references: "Os dados não são uma lista de referências",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "A carregar",
    local_changes_applied: "Alterações locais aplicadas ao formulário",
    local_changes_discarded: "Alterações locais descartadas",
    are_you_sure_leave: "Tem a certeza de que quer sair desta página?",
    see_console_details: "Consulte a consola para mais detalhes.",
    drop_here_create_group: "Solte aqui para criar um novo grupo",
    filter_for_null_values: "Filtrar valores nulos",
    value_updated_elsewhere: "Este valor foi atualizado noutro local",
    add_property: "Adicionar propriedade",
    edit_name: "Editar {{name}}",
    this_entity_not_exist: "Esta entidade não existe na base de dados",
    internal_error: "ERRO interno",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Renomear Grupo",
    group_name_label: "Nome do Grupo",
    group_name_empty_error: "O nome do grupo não pode estar vazio.",
    group_name_exists_error: "Este nome de grupo já existe.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Pesquisar coleções",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Visualizações",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Precisa de guardar a sua entidade antes de adicionar coleções adicionais",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Página não encontrada",
    page_not_found_body: "Esta página não existe ou pode não ter acesso a ela",
    back_to_home: "Voltar ao início",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Vista de coleção predefinida",
    table_view: "Tabela",
    cards_view: "Cartões",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Escolha como as entidades devem ser exibidas por padrão",

    document_view: "Vista de documento",
    side_panel: "Painel lateral",
    full_screen: "Ecrã inteiro",
    should_documents_opened_full_screen: "Os documentos devem ser abertos em ecrã inteiro ou num painel lateral inline",

    select_custom_view: "Selecionar vista personalizada",
    no_custom_views_defined: "Nenhuma vista personalizada definida. Defina as suas vistas personalizadas nas definições de personalização, antes de usar este diálogo.",

    select_custom_action: "Selecionar ação personalizada",
    no_custom_actions_defined: "Nenhuma ação personalizada definida. Defina as suas ações personalizadas nas definições de personalização, antes de usar este diálogo.",

    no_collections_found: "Nenhuma coleção encontrada",
    start_building_collections: "Comece a criar coleções no Rebase facilmente. Mapeie-as aos dados existentes na sua base de dados, importe de ficheiros ou use os nossos modelos.",
    create_first_collection: "Crie a sua primeira coleção",
    define_collections_programmatically: "Também pode definir coleções programaticamente.",
    edit_collection: "Editar coleção",
    no_permissions_edit_collection: "Não tem permissões para editar esta coleção",
    no_permissions_create_collection: "Não tem permissões para criar coleções",
    create_collection: "Criar coleção",
    update_collection: "Atualizar coleção",

    new_collection: "Nova coleção",
    add_new_collection: "Adicionar nova coleção",
    collection_with_name: "Coleção {{name}}",
    change_icon: "Alterar ícone",
    is_subcollection_of: "Esta é uma subcoleção de",
    name: "Nome",
    collection_name_description: "Nome desta coleção, normalmente um nome no plural (ex. Produtos)",
    path: "Caminho",
    relative_path_to_parent: "Caminho relativo ao pai (não é necessário incluir o caminho do pai)",
    path_in_database: "Caminho em que esta coleção está armazenada na base de dados",
    singular_name: "Nome singular",
    singular_name_description: "Opcionalmente defina um nome singular para as suas entidades",
    description: "Descrição",
    description_of_collection: "Descrição da coleção, pode usar markdown",
    collection_id: "ID da coleção",
    collection_id_description: "Este ID identifica esta coleção. Normalmente igual ao caminho.",
    collection_group: "Grupo de coleções",
    collection_group_description: "Um grupo de coleções consiste em todas as coleções com o mesmo caminho. Isto permite consultar várias coleções ao mesmo tempo.",
    advanced_settings: "Definições avançadas",
    doc_history_global: "Revisões do histórico do documento ativadas se ativadas globalmente",
    doc_history_enabled: "Revisões do histórico do documento ATIVADAS",
    doc_history_not_enabled: "Revisões do histórico do documento NÃO ativadas",
    doc_history_description: "Quando ativado, cada documento nesta coleção terá um histórico de alterações. Útil para fins de auditoria. Os dados são armazenados numa subcoleção do documento na sua base de dados, chamada __history.",
    document_id_generation: "Geração de IDs de documentos",
    code_defined: "Definido por código",
    users_must_define_id: "Os utilizadores devem definir um ID",
    users_can_define_id: "Os utilizadores podem definir um ID, mas não é obrigatório",
    doc_id_auto_generated: "O ID do documento é gerado automaticamente",
    config_doc_id_generation: "Configure como os IDs de documentos são gerados ao criar novas entidades.",
    enable_text_search: "Ativar pesquisa de texto para esta coleção",
    text_search_description: "Permitir pesquisa de texto para esta coleção. Se não especificou um delegado de pesquisa de texto, será usada a pesquisa de texto local integrada. Não recomendado para grandes coleções, pois pode causar problemas de desempenho e custo.",
    database_id: "ID da base de dados",
    default_text: "(predefinição)",

    custom_actions: "Ações personalizadas",
    more_info: "Mais informações",
    define_custom_actions_cli: "Defina as suas próprias ações personalizadas carregando-as com o CLI.",
    action_defined_in_code: "Esta ação está definida em código com a chave",
    add_custom_entity_action: "Adicionar ação de entidade personalizada",
    remove_this_action: "Remover esta ação?",
    remove_action_warning: "Isto não eliminará nenhum dado, apenas a ação no painel de administração",

    subcollections_of: "Subcoleções de",
    add_subcollection: "Adicionar subcoleção",
    custom_views: "Vistas personalizadas",
    define_custom_views_cli: "Defina as suas próprias vistas personalizadas carregando-as com o CLI.",
    view_defined_in_code: "Esta vista está definida em código com a chave",
    add_custom_entity_view: "Adicionar vista de entidade personalizada",
    delete_this_subcollection: "Eliminar esta subcoleção?",
    remove_collection_warning: "Isto não eliminará nenhum dado, apenas a coleção no painel de administração",
    remove_this_view: "Remover esta vista?",
    remove_view_warning: "Isto não eliminará nenhum dado, apenas a vista no painel de administração",

    no_collection_selected: "Nenhuma coleção selecionada",
    code_for_collection: "Código para",
    use_config_define_json: "Use esta configuração para definir a coleção em formato JSON.",
    customise_collection_code: "Se quiser personalizar a coleção em código, pode adicionar este código de coleção à configuração da sua aplicação de administração.",
    copied: "Copiado",

    property_cant_be_edited: "Esta propriedade não pode ser editada",
    property_not_editable_description: "Pode não ter permissão para editá-la ou está definida em código e não pode ser modificada.",
    delete_this_property: "Eliminar esta propriedade?",
    delete_property_warning: "Isto não eliminará nenhum dado, apenas modificará a coleção.",
    error_must_specify_id: "Deve especificar um id para o campo",
    error_id_format: "O id só pode conter letras, números e underscores (_), e não pode começar com um número",
    error_id_already_exists: "Já existe outro campo com este ID",
    error_must_specify_title: "Deve especificar um título para o campo",
    custom_or_other: "Personalizado/Outro",
    select_property_widget: "Selecionar um widget de propriedade",
    error_changing_data_type: "Este widget usa um tipo de dados diferente do widget inicialmente selecionado. Isto pode causar erros com dados existentes.",
    required: "Obrigatório",

    enum_form_dialog: "Diálogo de formulário enum",
    imported_data_preview: "Pré-visualização de dados importados",
    entities_with_same_id_overwritten: "Entidades com o mesmo id serão substituídas",
    collection_editor: "Editor de coleção",
    properties_in_this_group: "Propriedades neste grupo",
    data_property_mapping: "Mapeamento de propriedade de dados",
    property_edit_view: "Vista de edição de propriedade",
    all_of_these: "Todos estes",
    any_of_these: "Qualquer um destes",

    only_admins_edit_roles: "Apenas administradores podem editar funções",
    error_user_not_found: "Utilizador não encontrado",
    all_roles: "Todos os papéis",
    role: "Função",
    name_of_this_role: "Nome desta função",
    id_of_this_role: "ID desta função",
    create_entities: "Criar entidades",
    read_entities: "Ler entidades",
    update_entities: "Atualizar entidades",
    delete_entities: "Eliminar entidades",
    all_collections: "Todas as coleções",
    create_entities_in_collections: "Criar entidades em coleções",
    access_all_data_in_every_collection: "Aceder a todos os dados em todas as coleções",
    update_data_in_any_collection: "Atualizar dados em qualquer coleção",
    delete_data_in_any_collection: "Eliminar dados em qualquer coleção",
    allow_all_permissions_in_this_collections: "Permitir todas as permissões nestas coleções",
    all: "Todos",
    customise_permissions_description: "Pode personalizar as permissões que os utilizadores relacionados com esta função podem realizar nas entidades de cada coleção",
    create_collections: "Criar coleções",
    yes: "Sim",
    no: "Não",
    can_user_create_collections: "O utilizador pode criar coleções",
    edit_collections: "Editar coleções",
    only_own_collections: "Apenas as suas próprias",
    own: "Próprias",
    can_user_edit_collections: "O utilizador pode editar coleções",
    delete_collections: "Eliminar coleções",
    can_user_delete_collections: "O utilizador pode eliminar coleções",
    error_saving_role: "Ocorreu um erro ao guardar esta função",
    create_role: "Criar função",
    update: "Atualizar",

    only_admins_change_roles: "Apenas administradores podem alterar funções",
    must_be_at_least_one_admin: "Deve existir pelo menos um administrador",
    logged_user_not_found: "Utilizador com sessão iniciada não encontrado",
    user: "Utilizador",
    user_id: "ID do utilizador",
    name_of_this_user: "Nome deste utilizador",
    email_of_this_user: "Email deste utilizador",
    roles: "Funções",
    create_user: "Criar utilizador",

    users: "Utilizadores",
    add_user: "Adicionar utilizador",
    add_role: "Adicionar função",
    is_admin: "É Administrador",
    default_permissions: "Permissões predefinidas",
    created_on: "Criado em",
    email: "Email",
    id: "ID",
    read: "Ler",

    column_in_file: "Coluna no ficheiro",
    map_to_property: "Mapear para propriedade",
    default_values: "Valores predefinidos",
    default_values_description: "Pode selecionar um valor predefinido para colunas não mapeadas e valores vazios:",
    property: "Propriedade",
    default_value: "Valor predefinido",
    autogenerate_id: "Gerar ID automaticamente",
    id_column_description: "Coluna que será usada como ID para cada documento",
    do_not_set_value: "Não definir valor",
    set_value_to_true: "Definir valor como verdadeiro",
    set_value_to_false: "Definir valor como falso",
    drag_and_drop_file: "Arraste e solte um ficheiro aqui ou clique para carregar",
    error_saving_data: "Erro ao guardar dados",
    retry: "Tentar novamente",
    saving_data: "A guardar dados",
    entities_saved: "entidades guardadas",
    do_not_close_tab: "Não feche este separador ou a importação será interrompida",
    import: "Importar",
    import_data: "Importar dados",
    upload_file_description: "Carregue um ficheiro CSV, Excel ou JSON e mapeie-o para o esquema existente",
    back: "Voltar",
    next: "Seguinte",
    save_data: "Guardar dados",
    use_column_as_id: "Usar esta coluna como ID",
    do_not_import_property: "Não importar esta propriedade",
    entities_will_be_overwritten: "Entidades com o mesmo id serão substituídas",
    data_imported_successfully: "Dados importados com sucesso",
    export: "Exportar",
    export_data: "Exportar dados",
    download_table_csv: "Descarregar o conteúdo desta tabela como CSV",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Datas como timestamps",
    dates_as_strings: "Datas como strings",
    flatten_arrays: "Achatar listas",
    download: "Descarregar",
    large_number_of_documents: "Esta coleção tem um grande número de documentos ({{count}}).",
    too_many_documents_to_export: "Esta coleção tem mais documentos ({{count}}) do que o navegador consegue exportar num único ficheiro (limite {{limit}}). Filtre-a antes de exportar.",
    include_undefined_values: "Incluir valores indefinidos",
    submit: "Submeter",

    no_filterable_properties: "Não há propriedades filtráveis disponíveis",
    apply_filters: "Aplicar filtros",

    // ─── Filter Presets ──────────────────────────────────────────
    filter_presets: "Predefinições",
    filter_preset_apply: "Aplicar predefinição",
    filter_preset_active: "Ativo: {{label}}",

    list: "Lista",
    table_view_mode: "Tabela",
    cards: "Cartões",
    board: "Quadro",
    initialize_kanban_order_desc: "Isto atribuirá valores de ordem sequenciais a todos os itens que não tenham um. Os itens manterão a sua ordem atual dentro de cada coluna.",
    kanban_view_not_available: "A vista Kanban não está disponível",
    kanban_view_requires_enum: "A vista Kanban requer uma propriedade de string com valores enum para agrupar entidades em colunas. Adicione uma propriedade enum ao esquema da sua coleção para usar esta vista.",
    no_enum_values_configured: "Nenhum valor enum configurado para a propriedade \"{{property}}\"",
    items_need_backfill: "Alguns itens não têm valores de ordem. Inicialize para ativar a reordenação por arrastar e soltar.",
    kanban_order_not_configured: "A ordenação por arrastar e soltar não está configurada. Defina uma propriedade de ordem nas configurações da coleção para manter as posições dos cartões.",
    initialize: "Inicializar",
    confirm_multiple_delete: "Confirmar eliminação múltipla?",
    delete_entity_confirm_title: "Deseja eliminar este/a {{entityName}}?",
    add_existing: "Adicionar existente",
    unlink_entity_confirm_title: "Remover este/a {{entityName}} deste registo?",
    unlink_entity_confirm_body: "Continua em {{collectionName}} e disponível para outros registos.",
    confirm_multiple_unlink: "remover estes deste registo?",
    no_filter: "Sem filtro",
    is_true: "é verdadeiro",
    is_false: "é falso",
    error_uploading_file_size: "Erro ao carregar o ficheiro: excede {{maxSize}} bytes",
    error_uploading_file_type: "Erro ao carregar o ficheiro: tipo de ficheiro não suportado",
    drag_drop_files: "Arraste ficheiros para aqui, ou clique para os editar",
    drag_drop_file: "Arraste um ficheiro para aqui, ou clique para o editar",
    multiple_deleted: "Exclusão múltipla",
    some_entities_deleted: "Algumas entidades foram excluídas, mas não todas",
    error_deleting_entities: "Erro ao excluir entidades",
    deleted: "excluído(a)",
    selection_options: "Opções de seleção",
    selection_menu_all_loaded: "Tudo nesta página",
    selection_menu_all_matching: "Todos os {{total}} {{collection}}",
    selection_menu_none: "Nenhum",
    selection_select_all_loaded: "Selecionar as linhas carregadas",
    selection_deselect_all: "Desmarcar tudo",
    selection_reading_rows: "A ler linhas… {{loaded}} de {{total}}",
    selection_reading_rows_unknown: "A ler linhas… {{loaded}} até agora",
    selection_deleting_progress: "Eliminados {{completed}} de {{total}}",
    confirm_delete_selection: "Eliminar {{total}} {{collection}}?",
    confirm_delete_selection_unknown: "Eliminar todas as linhas que correspondem ao filtro atual?",
    confirm_delete_selection_body: "Esta ação não pode ser anulada. Cada linha é eliminada individualmente, pelo que pode demorar algum tempo.",

    export_selection_count: "Descarregar as {{total}} linhas selecionadas em {{format}}",
    export_selection_all_matching: "Descarregar todos os {{collection}} que correspondem ao filtro atual",

    select_reference: "Selecionar referência",
    select_references: "Selecionar referências",
    account_settings: "Definições da conta",
    profile: "Profile",
    security: "Segurança",
    sessions: "Sessions",
    change_password: "Alterar palavra-passe",
    current_password: "Palavra-passe atual",
    new_password: "Nova palavra-passe",
    confirm_password: "Confirmar a nova palavra-passe",
    password_changed: "Palavra-passe alterada com sucesso. A sua sessão será terminada.",
    passwords_dont_match: "As palavras-passe não coincidem",
    password_too_short: "A palavra-passe deve ter pelo menos 8 caracteres",
    password_change_not_available: "A alteração da palavra-passe não está disponível para contas que usam fornecedores de início de sessão externos.",
    changing_password: "A alterar...",
    display_name: "Nome a apresentar",
    photo_url: "URL da fotografia",
    save_profile: "Guardar perfil",
    saving: "Saving...",
    no_active_sessions: "Não foram encontradas sessões ativas.",
    revoking: "Revoking...",
    revoke_all_sessions: "Revogar todas as sessões",
    unknown_device: "Dispositivo desconhecido",
    current: "Current",
    role_id: "ID da função",
    role_name: "Nome da função",
    add_reference: "Adicionar referência",
    add_reference_to: "Adicionar referência a {{name}}",

    /** RolesView — table & permissions */
    role_deleted_successfully: "Função eliminada com sucesso",
    error_deleting_role: "Erro ao eliminar a função",
    collection_permissions: "Permissões da coleção",
    collection: "Collection",
    no_collections_configured: "Nenhuma coleção configurada",
    no_security_rules_defined: "Não há regras de segurança definidas — todas as operações estão sem restrições",
    no_rules: "sem regras",

    /** UsersView — snackbar */
    bootstrap_admin_success: "Já é administrador! A atualizar...",
    failed_to_bootstrap_admin: "Não foi possível criar o administrador inicial",
    user_deleted_successfully: "Utilizador eliminado com sucesso",
    error_deleting_user: "Erro ao eliminar o utilizador",
    user_created_successfully: "Utilizador criado com sucesso",
    invitation_sent: "Foi enviado um email de convite para {{email}}. A ligação permite definir a palavra-passe.",
    invitation_sent_title: "Convite enviado",
    temporary_password: "Palavra-passe temporária",
    temporary_password_description: "O email não está configurado. Partilhe esta palavra-passe temporária com o utilizador de forma segura. Não será mostrada novamente.",
    temporary_password_email_failed_description: "Não foi possível entregar o email. Partilhe esta palavra-passe temporária com o utilizador de forma segura. Não será mostrada novamente.",
    copy_password: "Copiar palavra-passe",
    password_copied: "Palavra-passe copiada para a área de transferência",

    /** UsersView — pagination & search */
    search_users: "Procurar utilizadores",
    created: "Criado",
    actions: "Ações",
    no_users_found: "Nenhum utilizador encontrado",
    reset_password: "Repor palavra-passe",
    reset_password_success: "Palavra-passe reposta com sucesso",
    reset_password_confirmation: "Tem a certeza de que pretende repor a palavra-passe deste utilizador?",
    reset_password_send_email: "Enviar um email de reposição da palavra-passe",
    reset_password_set_manually: "Definir uma palavra-passe manualmente",
    reset_password_set_manually_description: "A palavra-passe é atualizada de imediato e não é enviado qualquer email. Partilhe-a com o utilizador de forma segura.",

    /** Permission-denied empty states */
    no_permission_to_view_users: "Não tem permissão para ver os utilizadores",
    no_permission_to_view_roles: "Não tem permissão para ver as funções",
    no_permission_description: "Contacte um administrador se precisar de acesso a esta secção.",
    error_resetting_password: "Erro ao repor a palavra-passe",

    /** Editor table-bubble */
    add_row_before: "Inserir linha antes",
    add_row_after: "Inserir linha depois",
    delete_row: "Eliminar linha",
    add_column_before: "Inserir coluna antes",
    add_column_after: "Inserir coluna depois",
    delete_column: "Eliminar coluna",
    delete_table: "Eliminar tabela",

    /** Editor image-bubble */
    alt_text: "Texto alternativo",
    title: "Title",

    /** MapFieldBinding */
    a_property_of_this_map_has_error: "Uma propriedade deste mapa contém um erro",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Gerar Coleção com IA",
    modify_collection_with_ai: "Modificar Coleção com IA",
    describe_collection_to_create: "Descreva a coleção que quer criar.",
    describe_changes_to_make: "Descreva as alterações que quer fazer a esta coleção.",
    ai_placeholder_create: "ex.: Criar uma coleção de produtos com nome, preço, descrição e categoria...",
    ai_placeholder_modify: "ex.: Adicionar um campo de imagem miniatura com armazenamento, tornar o preço obrigatório...",
    ai_assist: "Assistente IA",
    generating: "A gerar...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "Esta é uma subcoleção de",
    use_existing_paths_database: "Use um dos caminhos existentes na sua base de dados:",
    describe_collection_ai: "Descreva a sua coleção à IA:",
    generate_with_ai: "Gerar com IA",
    create_from_json_config: "Criar a partir de configuração JSON:",
    paste_json_config: "Colar Configuração JSON",
    create_collection_from_file_formats: "Criar uma coleção a partir de um ficheiro (csv, json, xls, xslx...)",
    select_template: "Selecionar um modelo:",
    products: "Produtos",
    collection_products_subtitle: "Uma coleção de produtos com imagens, preços e stock",
    collection_users_subtitle: "Uma coleção de utilizadores com emails, nomes e funções",
    blog_posts: "Publicações de blog",
    collection_blog_posts_subtitle: "Uma coleção de publicações de blog com imagens, autores e conteúdo complexo",
    pages: "Páginas",
    collection_pages_subtitle: "Uma coleção de páginas com imagens, autores e conteúdo complexo",
    continue_from_scratch: "Continuar do zero",

    /** Admin views config */
    admin_users: "Utilizadores do painel de administração",
    roles_menu: "Funções",
    project_settings: "Definições do projeto",

    by_signing_in_you_agree_to_our: "Ao iniciar sessão, concorda com os nossos",
    terms_and_conditions: "Termos e Condições",
    and_our: "e a nossa",
    privacy_policy: "Política de privacidade",
    email_password: "Email/palavra-passe",
    sign_in_with_google: "Iniciar sessão com Google",

    // --- Auth error messages ---
    auth_user_not_found: "Utilizador não encontrado",
    auth_wrong_password: "Palavra-passe incorreta. Por favor tente novamente.",
    auth_user_disabled: "Utilizador desativado. Por favor contacte o suporte.",
    auth_account_exists_with_different_credential: "Conta existente com método de início de sessão diferente",
    auth_email_already_in_use: "O email já está em uso",
    auth_google_permissions_required: "Precisa de conceder permissões adicionais para gerir os seus projetos Google Cloud",
    auth_invalid_email_password: "Por favor introduza o email e a palavra-passe",
    auth_enter_email_first: "Por favor introduza primeiro o seu email",
    auth_password_reset_sent: "Email de redefinição de palavra-passe enviado",
    auth_sign_in_account: "Iniciar sessão na sua conta",
    auth_create_new_account: "Criar uma nova conta",
    auth_password: "Palavra-passe",
    auth_reset_password: "Redefinir palavra-passe",
    auth_new_user: "Novo utilizador?",
    auth_have_account: "Já tem uma conta?",
    auth_sign_in: "Iniciar Sessão",
    auth_sign_up: "Registar",


    auto_setup_collections_button: "Configurar coleções automaticamente",
    auto_setup_collections_title: "Configurar coleções automaticamente?",
    auto_setup_collections_desc: "Isto criará automaticamente configurações de coleção para coleções que <b>NÃO</b> estão já mapeadas",
    this_can_take_a_minute: "Isto pode demorar um ou dois minutos",
    no_collections_found_to_setup: "Nenhuma coleção encontrada para configurar.",
    collections_have_been_setup: "As coleções foram configuradas automaticamente.",
    error_setting_up_collections: "Erro ao configurar coleções automaticamente",

    // --- Home Suggestions ---

    admin_panel_ready_bring_data: "O seu painel de administração está pronto. Vamos importar os seus dados.",
    admin_panel_ready_get_started: "O seu painel de administração está pronto. Veja como começar.",
    auto_detect_collections: "Detetar coleções automaticamente",
    auto_detect_collections_desc: "Deixe a IA analisar a sua base de dados e gerar automaticamente esquemas de coleção.",
    create_a_collection: "Criar uma coleção",
    create_collection_desc: "Defina manualmente a sua primeira coleção do zero usando o editor visual.",
    read_the_docs: "Ler a documentação",
    read_the_docs_desc: "Saiba como personalizar campos, vistas, ações e muito mais.",
    explore_docs: "Explorar documentação",
    want_to_customize_with_code: "Quer personalizar com código? Execute",
    to_scaffold_a_local_project: "para criar um projeto local.",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validação",
    unique: "Único",
    required_message: "Mensagem de campo obrigatório",
    required_tooltip: "Você não poderá salvar esta entidade se este valor não estiver definido",
    unique_tooltip: "Não pode haver múltiplas entidades com o mesmo valor",
    lowercase: "Minúsculas",
    uppercase: "Maiúsculas",
    trim: "Remover espaços",
    exact_length: "Comprimento exato",
    min_length: "Comprimento mín.",
    max_length: "Comprimento máx.",
    matches_regex: "Corresponde a regex",
    not_valid_regexp: "Expressão regular inválida",
    regex_helper: "ex. /^\\d+$/ apenas para dígitos",
    min_value: "Valor mín.",
    max_value: "Valor máx.",
    less_than: "Menor que",
    more_than: "Maior que",
    positive_value: "Valor positivo",
    negative_value: "Valor negativo",
    integer_value: "Valor inteiro",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Expressão regular inválida",
    must_specify_target_collection: "Você deve especificar uma coleção de destino para o campo",
    need_specify_repeat_field: "Você precisa especificar um campo de repetição",
    need_specify_block_properties: "Você precisa especificar as propriedades deste bloco",
    incomplete_condition: "Condição incompleta - por favor selecione um campo",
    field_name: "Nome do campo",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Propriedade de coluna Kanban",
    select_a_property: "Selecionar uma propriedade",
    kanban_property_not_found: "A propriedade \"{{property}}\" não existe ou não é uma propriedade string com enum. Selecione uma propriedade válida ou limpe a seleção.",
    no_enum_string_properties: "Nenhuma propriedade string com enum encontrada. Adicione uma propriedade string com enumValues para usar a visualização Kanban.",
    kanban_column_description: "Selecione uma propriedade string com valores enum para agrupar entidades em colunas",
    create_property: "+ Criar propriedade \"{{property}}\"",
    order_property: "Propriedade de ordem",
    order_property_not_found: "A propriedade \"{{property}}\" não existe ou não é uma propriedade numérica. Selecione uma propriedade válida ou limpe a seleção.",
    no_number_properties: "Nenhuma propriedade numérica encontrada. Adicione uma propriedade numérica para habilitar a ordenação.",
    order_property_description: "Selecione uma propriedade numérica para manter a ordem dos itens",
    display_settings: "Configurações de exibição",
    default_row_size: "Tamanho de linha padrão",
    side_dialog_width: "Largura do diálogo lateral",
    side_dialog_width_description: "Defina opcionalmente a largura (em pixels) do diálogo lateral de entidades. O padrão é 768px",
    inline_editing_enabled: "Os dados podem ser editados diretamente na visualização de tabela",
    inline_editing_disabled: "Os dados só podem ser editados na visualização de formulário",
    inline_editing_description: "Permitir edição de dados diretamente na visualização de tabela, sem abrir a visualização de formulário.",
    include_json_view: "Incluir visualização JSON",
    no_json_view: "Não incluir visualização JSON",
    json_view_description: "Incluir a representação JSON do documento.",
    not_found_suffix: "não encontrado",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Texto",
    editor_text_description: "Comece simplesmente a escrever em texto simples.",
    editor_heading_1: "Título 1",
    editor_heading_1_description: "Título de secção grande.",
    editor_heading_2: "Título 2",
    editor_heading_2_description: "Título de secção médio.",
    editor_heading_3: "Título 3",
    editor_heading_3_description: "Título de secção pequeno.",
    editor_todo_list: "Lista de Tarefas",
    editor_todo_list_description: "Acompanhe tarefas com uma lista de afazeres.",
    editor_bullet_list: "Lista com Marcadores",
    editor_bullet_list_description: "Crie uma lista simples com marcadores.",
    editor_numbered_list: "Lista Numerada",
    editor_numbered_list_description: "Crie uma lista com numeração.",
    editor_quote: "Citação",
    editor_quote_description: "Capture uma citação.",
    editor_code: "Código",
    editor_code_description: "Capture um snippet de código.",
    editor_image: "Imagem",
    editor_image_description: "Carregue uma imagem do seu computador.",
    editor_multiple: "Múltiplos",
    editor_link: "Ligação",
    editor_save: "Guardar",
    editor_cancel: "Cancelar",
    editor_remove_link: "Remover ligação",
    editor_paste_or_type_link: "Cole ou escreva a ligação",
    editor_open_in_new_window: "Abrir numa nova janela",
    editor_bold: "Negrito",
    editor_italic: "Itálico",
    editor_underline: "Sublinhado",
    editor_strikethrough: "Riscado",
    editor_autocomplete: "Preenchimento automático",
    editor_autocomplete_description: "Adicione texto com base no contexto.",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Ativar pesquisa de texto",
    text_search_local_not_recommended: "A pesquisa de texto local não é recomendada para coleções grandes.",
    text_search_local_fetch_warning: "Note que ativar a pesquisa de texto local requer descarregar todos os documentos da sua coleção e armazená-los no navegador. Isto pode ser ineficiente para coleções grandes e gerar custos adicionais.",
    text_search_external_suggestion: "Para coleções maiores, recomendamos usar um motor de pesquisa externo como Algolia ou Elastic Search e atribuir um delegado de pesquisa à sua configuração.",
    text_search_local_description: "A pesquisa de texto local é a forma mais simples de ativar a pesquisa de texto na sua coleção. Carrega todos os documentos da coleção no navegador e efetua a pesquisa localmente. É a opção recomendada para coleções pequenas.",
    text_search_own_implementation: "Implementou o seu próprio controlador de pesquisa de texto. Pode ativar a pesquisa de texto para a sua coleção.",
    text_search_enable_for_collection: "Ativar para esta coleção",
    text_search_enable_for_project: "Ativar para o projeto",
    text_search_enabled_snackbar: "Pesquisa de texto local ativada",

    settings_heading: "Definições",
    settings_project_name: "Nome do projeto",
    settings_default_language: "Idioma predefinido",
    settings_default_language_caption: "Selecione o idioma base para este projeto. Os utilizadores podem alterar esta preferência nas suas definições pessoais.",
    settings_enable_local_text_search: "Ativar pesquisa de texto local",
    settings_local_text_search_caption: "Ative a pesquisa de texto local para todas as coleções. Isto permitirá pesquisar campos de texto nas suas coleções usando a barra de pesquisa do Rebase. Note que esta funcionalidade pode resultar num maior número de leituras, pois todos os campos de texto das suas coleções serão indexados.",
    settings_doc_history_all_collections: "Histórico de documentos ativado para todas as coleções",
    settings_doc_history_caption: "Quando ativado, todas as coleções terão o histórico ativado por predefinição. Pode alterar esta definição em cada coleção. O histórico será guardado na subcoleção __history de cada documento.",
    settings_theme: "Tema",
    settings_primary_color: "Cor primária",
    settings_secondary_color: "Cor secundária",
    settings_sample_theme_components: "Exemplos de componentes do tema",
    settings_drag_drop_logo: "Arraste e solte o seu logótipo aqui",
    settings_security_rules: "Regras de segurança",
    settings_security_rules_description: "O Rebase utiliza as regras de segurança do Firebase para restringir o acesso aos dados. Ao criar um novo utilizador através do Rebase, o atributo personalizado rebaseUser é adicionado ao utilizador no projeto cliente. Ao adicionar as seguintes regras de segurança ao seu projeto, garante que os utilizadores do Rebase possam aceder aos dados através do Rebase.",
    settings_security_rules_add_domain: "Lembre-se de adicionar o domínio {{domain}} aos domínios permitidos do seu fornecedor",
    settings_security_rules_caption: "Estas regras restringem o acesso aos dados apenas aos utilizadores do Rebase, mas não aplicam as permissões ao nível da base de dados. As permissões são aplicadas no frontend, o que funciona bem para a maioria dos projetos. Se precisar de aplicar as permissões ao nível da base de dados, pode modificar estas regras de segurança. As funções atribuídas a um utilizador são definidas como atributos personalizados no token de autenticação do Firebase, pelo que pode utilizá-las nas suas regras de segurança.",

    // ─── Studio: SQL Editor ─────────────────────────────────────
    studio_sql_executing_query: "A EXECUTAR A CONSULTA...",
    studio_sql_query_error: "Erro na consulta",
    studio_sql_run_query_placeholder: "Execute uma consulta para ver os resultados",
    studio_sql_visual_execution_plan: "Plano de execução visual",
    studio_sql_success: "SUCCESS",
    studio_sql_no_results: "A consulta foi executada com sucesso mas não devolveu resultados.",
    studio_sql_rows: "Rows:",
    studio_sql_time: "Time:",
    studio_sql_copy_markdown: "Copiar como Markdown",
    studio_sql_export_json: "Exportar JSON",
    studio_sql_export_csv: "Exportar CSV",
    studio_sql_format_sql: "Formatar SQL",
    studio_sql_explain: "Explain",
    studio_sql_limit_1000: "Limit 1000",
    studio_sql_remove_from_favorites: "Remover dos favoritos",
    studio_sql_add_to_favorites: "Adicionar aos favoritos",
    studio_sql_save: "Save",
    studio_sql_run: "Run",
    studio_sql_database: "Database",
    studio_sql_role: "Role",
    studio_sql_admin: "(Admin)",
    studio_sql_select_db: "Escolher base de dados",
    studio_sql_query_results: "Resultados da consulta",
    studio_sql_save_snippet: "Guardar excerto SQL",
    studio_sql_snippet_name: "Nome do excerto",
    studio_sql_snippet_name_placeholder: "p. ex., Obter todos os utilizadores",
    studio_sql_snippet_saved_local: "Será guardado no seu armazenamento local.",
    studio_sql_cancel: "Cancel",
    studio_sql_dangerous_operation: "Operação perigosa detetada",
    studio_sql_dangerous_operation_body: "A consulta que está prestes a executar contém operações potencialmente destrutivas (DELETE, DROP, TRUNCATE ou UPDATE sem WHERE). Tem a certeza de que pretende continuar?",
    studio_sql_snippet_saved: "Excerto «{{name}}» guardado.",
    studio_sql_markdown_copied: "Resultados copiados como Markdown!",
    studio_sql_markdown_copy_failed: "Não foi possível copiar o Markdown para a área de transferência.",
    studio_sql_row_updated: "Linha atualizada com sucesso.",
    studio_sql_cannot_edit_missing_query: "Não é possível editar as linhas: falta a consulta subjacente.",
    studio_sql_cannot_resolve_table: "Não foi possível determinar a tabela ou a chave primária",
    studio_sql_missing_pk: "Faltam colunas de chave primária na linha: {{columns}}. Não é possível atualizar em segurança.",
    studio_sql_update_failed: "Falha ao atualizar: {{message}}",
    studio_sql_execution_not_supported: "A fonte de dados atual não suporta a execução de SQL.",
    studio_sql_error_executing: "Ocorreu um erro ao executar a consulta.",
    studio_sql_error_explaining: "Ocorreu um erro ao explicar a consulta.",
    studio_sql_save_first_to_favorite: "Guarde o excerto antes de o marcar como favorito.",
    studio_sql_collections_label: "Collections:",
    studio_sql_admin_collections_tooltip: "Tables in this query that are mapped as admin collections",
    studio_sql_edit_entity: "Edit {{name}} #{{id}}",
    studio_sql_sql_not_supported: "Esta fonte de dados não suporta a execução de SQL",
    studio_sql_fetch_error: "Não foi possível obter as opções de ligação: {{message}}",
    studio_sql_unexpected_format: "Formato de dados inesperado: {{type}}",
    studio_sql_no_tables: "Não foram encontradas tabelas nesta base de dados.",
    studio_sql_schema_fetch_error: "Não foi possível obter o esquema: {{message}}",

    // ─── Studio: SQL Editor Sidebar ──────────────────────────────
    studio_sql_sidebar_snippets: "Snippets",
    studio_sql_sidebar_history: "History",
    studio_sql_sidebar_schema: "Schema",
    studio_sql_sidebar_no_snippets: "Não há excertos guardados",
    studio_sql_sidebar_save_snippet_hint: "Guarde uma consulta para lhe aceder aqui.",
    studio_sql_sidebar_no_history: "Sem histórico",
    studio_sql_sidebar_history_hint: "As consultas executadas aparecerão aqui.",
    studio_sql_sidebar_delete_snippet: "Eliminar excerto",
    studio_sql_close_tab: "Fechar este separador de consulta",
    studio_sql_new_tab: "Novo separador de consulta",

    // ─── Studio: Schema Browser ──────────────────────────────────
    studio_schema_tables: "Tables",
    studio_schema_loading: "A carregar o esquema...",
    studio_schema_no_tables: "Nenhuma tabela encontrada",
    studio_schema_retry: "Retry",
    studio_schema_primary_key: "Chave primária",
    studio_schema_select_all: "SELECT * FROM",
    studio_schema_insert_into: "INSERT INTO",
    studio_schema_update: "UPDATE",
    studio_schema_delete_from: "DELETE FROM",
    studio_schema_columns: "{{count}} colunas",

    // ─── Studio: RLS Editor ──────────────────────────────────────
    studio_rls_title: "Segurança ao nível da linha",
    studio_rls_description: "Gerir as políticas RLS das suas tabelas",
    studio_rls_enabled: "RLS ativada",
    studio_rls_disabled: "RLS desativada",
    studio_rls_no_rls: "Sem RLS",
    studio_rls_enable_rls: "Ativar RLS",
    studio_rls_disable_rls: "Desativar RLS",
    studio_rls_create_policy: "Criar política",
    studio_rls_policies: "Policies",
    studio_rls_no_policies: "Não há políticas definidas",
    studio_rls_no_policies_desc: "Esta tabela não tem políticas RLS. O acesso a todas as linhas depende do estado da RLS.",
    studio_rls_add_first_policy: "Adicionar a sua primeira política",
    studio_rls_force_rls: "Forçar RLS",
    studio_rls_force_rls_desc: "Quando ativado, as políticas RLS aplicam-se também ao proprietário da tabela.",
    studio_rls_enable_force_rls: "Ativar RLS forçada",
    studio_rls_disable_force_rls: "Desativar RLS forçada",
    studio_rls_edit: "Edit",
    studio_rls_delete: "Delete",
    studio_rls_confirm_delete_title: "Eliminar política",
    studio_rls_confirm_delete_body: "Tem a certeza de que pretende eliminar esta política? Esta ação não pode ser anulada.",
    studio_rls_confirm_enable_title: "Ativar a segurança ao nível da linha",
    studio_rls_confirm_enable_body: "Ao ativar a RLS, o acesso às linhas desta tabela passa a ser limitado pelas suas políticas. Certifique-se de que tem políticas adequadas.",
    studio_rls_confirm_disable_title: "Desativar a segurança ao nível da linha",
    studio_rls_confirm_disable_body: "Ao desativar a RLS, todas as linhas ficarão acessíveis a todas as funções. Tem a certeza de que pretende continuar?",
    studio_rls_select_table: "Selecione uma tabela",
    studio_rls_no_tables: "Não há tabelas disponíveis",
    studio_rls_error: "Erro ao carregar as políticas",
    studio_rls_retry: "Retry",
    studio_rls_loading: "A carregar as políticas...",

    // ─── Studio: Policy Editor ───────────────────────────────────
    studio_policy_edit: "Editar política",
    studio_policy_create: "Criar uma nova política",
    studio_policy_defining_rules: "A definir regras de acesso para",
    studio_policy_cancel: "Cancel",
    studio_policy_save: "Guardar política",
    studio_policy_template: "Começar a partir de um modelo (opcional)",
    studio_policy_select_template: "Selecione um modelo...",
    studio_policy_name: "Nome da política",
    studio_policy_name_placeholder: "Dê à sua política um nome descritivo",
    studio_policy_behavior: "Comportamento da política",
    studio_policy_permissive: "Permissive",
    studio_policy_permissive_desc: "Combinada com «OR»",
    studio_policy_restrictive: "Restrictive",
    studio_policy_restrictive_desc: "Combinada com «AND»",
    studio_policy_command: "Comando da política",
    studio_policy_target_roles: "Funções alvo",
    studio_policy_roles_placeholder: "Selecione funções (por omissão, public)",
    studio_policy_using_expr: "Expressão USING",
    studio_policy_using_expr_desc: "Aplica-se às linhas existentes (SELECT, UPDATE, DELETE)",
    studio_policy_check_expr: "Expressão WITH CHECK",
    studio_policy_check_expr_desc: "Aplica-se às linhas novas ou modificadas (INSERT, UPDATE)",
    studio_policy_help_title: "Guia da segurança ao nível da linha (RLS)",
    studio_policy_help_intro: "A segurança ao nível da linha (RLS) permite restringir as linhas a que um utilizador pode aceder ou que pode modificar, consoante o seu estado de autenticação ou as suas funções.",
    studio_policy_help_step1_title: "1. Selecione um modelo",
    studio_policy_help_step1_desc: "Se está a começar com a RLS, o mais simples é escolher um modelo predefinido na lista. Configura automaticamente a política para casos comuns como «os utilizadores podem atualizar as suas próprias linhas».",
    studio_policy_help_step2_title: "2. Funções alvo",
    studio_policy_help_step2_desc: "Escolha a que utilizadores se aplica a política:",
    studio_policy_help_role_public: "Aplica-se a toda a gente (com sessão iniciada ou não).",
    studio_policy_help_role_authenticated: "Aplica-se apenas aos utilizadores com sessão iniciada.",
    studio_policy_help_role_anon: "Aplica-se apenas aos utilizadores que NÃO iniciaram sessão.",
    studio_policy_help_step3_title: "3. Expressão USING",
    studio_policy_help_step3_desc: "Uma condição SQL que tem de ser verdadeira para que as linhas existentes sejam visíveis ou atualizáveis (SELECT, UPDATE, DELETE).",
    studio_policy_help_step3_example: "Garante que os utilizadores só veem as linhas de que são proprietários.",
    studio_policy_help_step4_title: "4. Expressão WITH CHECK",
    studio_policy_help_step4_desc: "Uma condição SQL que tem de ser verdadeira para que as linhas novas ou modificadas sejam guardadas (INSERT, UPDATE).",
    studio_policy_help_step4_example: "Normalmente é igual à expressão USING quando os utilizadores só podem inserir ou editar os seus próprios dados.",
    studio_policy_help_auth_vars_title: "Variáveis de autenticação do Rebase",
    studio_policy_help_auth_vars_desc: "O Rebase fornece funções nativas que pode usar nas suas expressões:",
    studio_policy_help_auth_uid: "Devolve o ID do utilizador atual como texto. Exemplo:",
    studio_policy_help_auth_jwt: "Devolve todo o payload do JWT como JSONB, para que possa verificar claims personalizadas. Exemplo:",
    studio_policy_help_auth_roles: "Devolve os IDs das funções do utilizador como uma cadeia separada por vírgulas. Utilize preferencialmente com:",
    studio_policy_help_docs_cta: "Para saber mais sobre as políticas do Postgres, consulte a documentação oficial.",
    studio_policy_help_read_docs: "Ler a documentação",
    studio_policy_help_got_it: "Percebi!",

    // ─── Studio: UI Actions ──────────────────────────────────────
    studio_add_kanban_column: "Adicionar coluna",
    studio_add_kanban_column_title: "Adicionar coluna ao Kanban",
    studio_add_kanban_column_name: "Nome da coluna",
    studio_add_kanban_column_name_placeholder: "Nome da nova coluna",
    studio_add_kanban_column_add: "Add",
    studio_add_kanban_column_cancel: "Cancel",
    studio_collection_view_sql: "Editor SQL",
    studio_collection_view_admin: "Vista de administração",
    studio_editor_collection_tooltip: "Editar o esquema da coleção",
    studio_editor_collection_no_permission: "Não tem permissão para editar esta coleção",
    studio_editor_collection_start_tooltip: "Copiar o caminho ou editar o esquema",
    studio_editor_collection_start_no_permission: "Não tem permissão para modificar esta coleção",
    studio_editor_collection_start_copied: "Copied!",
    studio_editor_entity_tooltip: "Editar o esquema da entidade",
    studio_editor_entity_no_permission: "Não tem permissão para editar esta entidade",
    studio_home_edit_collection: "Editar coleção",
    studio_home_delete_collection: "Eliminar coleção",
    studio_home_confirm_delete_title: "Eliminar a coleção?",
    studio_home_confirm_delete_body: "Tem a certeza de que pretende eliminar a coleção «{{name}}»? Esta ação não pode ser anulada.",
    studio_kanban_setup: "Configuração do Kanban",
    studio_missing_reference: "Referência em falta: {{path}}",
    studio_missing_reference_create: "Create",
    studio_new_collection: "Nova coleção",
    studio_new_collection_card: "Nova coleção",
    studio_new_collection_no_permission: "Não tem permissões para criar coleções",
    studio_property_add_column: "Adicionar uma nova propriedade",
    studio_property_add_column_no_permission: "Não tem permissão para adicionar novas propriedades",
    studio_add_kanban_column_desc: "Adiciona uma nova opção à propriedade «{{property}}». Será criada uma nova coluna no quadro Kanban.",
    studio_add_kanban_column_adding: "Adding...",
    studio_collection_view_edit: "Edit",
    studio_editor_collection_disabled: "A edição de coleções está desativada",
    studio_editor_collection_edit: "Editar coleção",
    studio_editor_entity_save_first: "Tem de guardar o documento antes de alterar o esquema",
    studio_editor_entity_edit_schema: "Editar o esquema deste formulário",
    studio_editor_collection_start_save_filter: "Guardar o filtro e a ordenação predefinidos",
    studio_editor_collection_start_clear_filter: "Limpar o filtro e a ordenação predefinidos",
    studio_editor_collection_start_reset_filter: "Repor o filtro e a ordenação predefinidos",
    studio_editor_collection_start_saved: "Configuração predefinida guardada",
    studio_home_duplicate_collection: "Duplicate",
    studio_home_delete: "Delete",
    studio_home_confirm_delete_no_data: "Não serão eliminados dados, apenas a coleção no painel de administração",
    studio_home_collection_deleted: "Coleção eliminada",
    studio_kanban_configure: "Configurar o Kanban",
    studio_missing_reference_error: "Não há coleção para o caminho: {{path}}",
    studio_new_collection_add: "Adicionar nova coleção",

    // ─── Property field labels ──────────────────────────────────
    db_column_type: "Tipo de coluna do banco de dados",
    primary_key_unique_id: "Chave primária / ID único",
    spread_children_as_columns: "Expandir filhos como colunas",
    mode: "Modo",
    timezone: "Fuso horário",
    target_collection: "Coleção de destino",

    // ─── Storage property ───────────────────────────────────────
    storage_file_name: "Nome do arquivo",
    storage_path: "Caminho de armazenamento",
    storage_max_size: "Tamanho máximo (em bytes)",
    storage_resize_mode: "Modo de redimensionamento",
    storage_output_format: "Formato de saída",
    storage_max_width: "Largura máxima (px)",
    storage_max_height: "Altura máxima (px)",
    storage_quality: "Qualidade (0-100)",
    storage_file_upload_config: "Configuração de upload de arquivo",
    storage_image_resize_config: "Configuração de redimensionamento de imagem",
    storage_all_file_types: "Todos os tipos de arquivo permitidos",
    storage_allowed_file_types: "Tipos de arquivo permitidos",
    storage_include_bucket_url: "Incluir URL do bucket (s3://...) no valor salvo",
    storage_save_url: "Salvar URL em vez do caminho de armazenamento",

    // ─── DateTime property ──────────────────────────────────────
    datetime_automatic_value: "Valor automático",

    // ─── Markdown property ──────────────────────────────────────
    markdown_paste_behavior: "Comportamento ao colar",

    // ─── Entity identity bar and inspector ──────────────────────
    entity_saved: "Guardado",
    more_actions: "Mais ações",
    record_history: "Histórico",
    inspect_record: "Inspecionar registo",
    inspect: "Inspecionar",
    close_inspector: "Fechar o inspetor",
    open_in_live_site: "Abrir no site publicado",

    // ─── Revision history ───────────────────────────────────────
    history_revert: "Voltar a esta versão",
    history_revert_title: "Reverter os dados para esta versão?",
    history_reverted: "Revertido para a versão selecionada",
    history_revert_error: "Erro ao reverter o registo",
    history_revert_dirty: "Guarde ou descarte as suas alterações antes de reverter",
    history_empty: "Nenhum histórico disponível",
    history_empty_description: "Ao guardar um registo é criada uma nova versão, guardada no histórico.",
    history_new_entity: "O histórico só está disponível para registos existentes",
    history_no_more: "Sem mais histórico",

    // ─── Studio: tools, groups and empty states ─────────────────
    // The admin's own three groups, read by `useNavigationGroupLabel` the same
    // way as the Studio ones below — the group *name* is an identifier the
    // ordering and the icons key off, and only the heading is translated.
    studio_group_views: "Visualizações",
    studio_group_admin: "Administração",
    studio_group_settings: "Definições",
    studio_group_database: "Base de dados",
    studio_group_compute: "Computação",
    studio_group_storage: "Armazenamento",
    studio_group_api: "API",
    studio_group_access_control: "Controlo de acesso",
    studio_tool_sql: "Consola SQL",
    studio_tool_sql_description: "Executa consultas SQL",
    studio_tool_js: "Consola JS",
    studio_tool_js_description: "Executa JavaScript",
    studio_tool_rls: "Políticas RLS",
    studio_tool_rls_description: "Segurança ao nível da linha",
    studio_tool_storage: "Armazenamento",
    studio_tool_storage_description: "Gere os ficheiros de armazenamento",
    studio_tool_cron: "Tarefas cron",
    studio_tool_cron_description: "Gere as tarefas agendadas",
    studio_tool_schema_visualizer: "Visualizador de esquema",
    studio_tool_schema_visualizer_description: "Diagrama ER interactivo da base de dados",
    studio_tool_branches: "Ramos",
    studio_tool_branches_description: "Cria e gere ramos da base de dados",
    studio_tool_backups: "Cópias de segurança",
    studio_tool_backups_description: "Descarrega cópias de segurança da base de dados",
    studio_tool_api: "Explorador de API",
    studio_tool_api_description: "Documentação de API interactiva e testes",
    studio_tool_logs: "Explorador de registos",
    studio_tool_logs_description: "Registos de sistema e consultas em tempo real",
    studio_tool_api_keys: "Chaves de API",
    studio_tool_api_keys_description: "Cria e gere chaves de API com âmbito",
    studio_backups_denied_title: "Não pode listar as cópias de segurança deste projeto",
    studio_backups_denied_hint: "O projeto não tem nada de errado. Listar cópias de segurança exige uma ligação de administrador, e a conta com sessão iniciada foi recusada.",
    studio_backups_read_failed: "Não foi possível ler as cópias de segurança deste projeto",
    studio_backups_downloading: "A descarregar…",
    studio_backups_roles_file: "Ficheiro de funções",
    studio_backups_roles_file_hint: "O .globals.sql guardado com esta cópia. Recria as funções da base de dados a que se referem as permissões e a segurança ao nível da linha do dump, e o `rebase db restore` lê-o ao lado do .dump, por isso mantenha os dois ficheiros juntos.",
    studio_backups_no_roles_file: "Sem ficheiro de funções",
    studio_backups_no_roles_file_hint: "Esta cópia não tem nenhum .globals.sql. Restaurá-la num Postgres novo para na primeira permissão concedida a uma função da base de dados que lá não existe.",
    studio_cron_denied_title: "Não pode listar as tarefas cron deste projeto",
    studio_cron_denied_hint: "O projeto não tem nada de errado. A API de cron é apenas para administradores, e a conta com sessão iniciada foi recusada.",
    studio_cron_read_failed: "Não foi possível ler as tarefas cron deste projeto",
    studio_api_keys_denied_title: "Não pode listar as chaves de API deste projeto",
    studio_api_keys_denied_hint: "O projeto não tem nada de errado. Gerir chaves de API é uma operação de administrador, e a conta com sessão iniciada foi recusada.",
    studio_api_keys_read_failed: "Não foi possível ler as chaves de API deste projeto",
    studio_api_keys_empty_title: "Ainda não há chaves de API",
    studio_api_keys_empty_hint: "Crie uma chave para permitir a autenticação entre serviços",
    studio_api_keys_revoke: "Revogar",
    studio_api_keys_select_hint: "Selecione uma chave de API para ver os detalhes",
    studio_api_keys_permissions: "Permissões",
    studio_api_keys_no_permissions: "Nenhuma permissão configurada",
    studio_api_keys_revoke_confirmation: "Confirmação de revogação",
    studio_api_keys_name_label: "Nome:",
    studio_api_keys_access_label: "Acesso:",
    studio_api_keys_admin_granted: "Papel de administrador concedido",
    studio_api_keys_admin_granted_hint: "as rotas de administração e as políticas default_admin",
    studio_api_keys_done: "Concluído",
    studio_api_keys_status_active: "Ativa",
    studio_api_keys_status_expired: "Expirada",
    studio_api_keys_status_revoked: "Revogada",
    studio_api_keys_stat_status: "Estado",
    studio_api_keys_stat_last_used: "Última utilização",
    studio_api_keys_stat_expires: "Expira",
    studio_api_keys_never: "Nunca",
    studio_api_keys_role_service: "Serviço",
    studio_api_keys_stat_rate_limit: "Limite de pedidos",
    studio_api_keys_rate_limit_default: "Predefinido (1000/15 min)",
    studio_api_keys_stat_created_by: "Criada por",
    studio_api_keys_copy_failed: "Não foi possível copiar",
    studio_branches_denied_title: "Não pode listar os ramos deste projeto",
    studio_branches_denied_hint: "O projeto não tem nada de errado. Os ramos usam a ligação de administrador, e a conta com sessão iniciada foi recusada.",
    studio_branches_read_failed: "Não foi possível ler os ramos deste projeto",
    studio_schema_no_collections: "Nenhuma coleção declarada",
    studio_schema_no_collections_body: "Ainda não há nada para desenhar. Adicione uma coleção em config/collections/, ou abra «Editar coleções» para adicionar uma aqui.",
    studio_schema_introspect_hint: "Numa base de dados que já tem tabelas, rebase schema introspect escreve os ficheiros de coleção por si.",


    // ─── Studio: RLS editor confirmations ───────────────────────
    studio_rls_enable_confirm_title: "Activar a segurança ao nível da linha?",
    studio_rls_enable_confirm_body: "Até que uma política o permita, nenhuma linha de {{table}} é legível. O Postgres nega por omissão.",
    studio_rls_disable_confirm_title: "Desactivar a segurança ao nível da linha?",
    studio_rls_disable_confirm_body: "Todas as políticas de {{table}} deixam de ser aplicadas. Quem alcançar a tabela pode ler e escrever todas as linhas.",
    studio_rls_drop_policy_title: "Eliminar esta política?",
    studio_rls_drop_policy_body: "{{policy}} é removida de {{table}} na base de dados. Nada é escrito no seu código, portanto um deploy pode repô-la.",
    studio_rls_unapplied: "Por aplicar",
    studio_rls_unapplied_tooltip: "Declarada no seu código, ainda não na base de dados. Guarde-a aqui para planear e aplicar a alteração, ou execute `rebase db push`.",


    // ─── Studio: empty states that name a remedy ────────────────
    studio_branches_unavailable_title: "A criação de ramos da base de dados não está disponível",
    studio_branches_unavailable_body: "Os ramos precisam de um backend Postgres com uma ligação de administrador. Defina ADMIN_CONNECTION_STRING no ambiente do backend.",
    studio_backups_not_configured_title: "As cópias de segurança não estão configuradas",
    studio_backups_not_configured_body: "Defina BACKUP_DESTINATION para um caminho local ou um URL s3:// ou gs://, e depois crie uma cópia com `rebase db backup` ou um cron agendado.",
    studio_cron_empty_title: "Nenhuma tarefa cron registada",
    studio_cron_empty_body: "Adicione um ficheiro em backend/crons/ que exporte por omissão uma CronJobDefinition.",
    studio_read_the_docs: "Consulte a documentação"
};
